import { render, staticRenderFns } from "./ViewerMenuDesign.vue?vue&type=template&id=7562a246&scoped=true"
import script from "./ViewerMenuDesign.vue?vue&type=script&lang=js"
export * from "./ViewerMenuDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerMenuDesign.vue?vue&type=style&index=0&id=7562a246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7562a246",
  null
  
)

export default component.exports